import OAuth from 'oauth-1.0a';
import crypto from 'crypto';

export function authorizeOAuth(data) {
  let oauth = OAuth({
    consumer: {
      key: data.consumerKey,
      secret: data.consumerSecret
    },
    signature_method: data.signatureMethod,
    hash_function: function(base_string, key) {
      return crypto
        .createHmac('sha1', key)
        .update(base_string)
        .digest('base64');
    }
  });
  return oauth.authorize(data);
}
